export default __webpack_public_path__ + "static/Aicpa-square-95d0cf4c0fc9988142e3e52cf418abc2.png";